export { default } from './AlertsCard';
